/* RC design system — collection "Load More" pager (2026-08-17).
   Big filterable collections (e.g. 95 drawers) render every product in the DOM so the
   CLIENT-SIDE facet engine can filter without a reload. That means a long scroll. This
   pager shows only page_size cards, and reveals page_size more per click, operating on the
   facet-FILTERED set: it listens for the 'rcds:facets-applied' event the facet engine emits
   and re-pages the currently-visible cards, resetting to page 1 whenever the filter changes.

   Mechanism: cards beyond the current page get .rcds-fitem--over (display:none). This is a
   SEPARATE channel from the facet engine's [hidden] attribute, so the two never fight:
   a card shows only when it is neither [hidden] (facet mismatch) nor --over (page overflow).
   Progressive enhancement: with no JS, no card gets --over and the button stays hidden, so
   every product shows (nothing lost, still crawlable). */
(function () {
  'use strict';
  if (window.__rcdsMoreInit) return;
  window.__rcdsMoreInit = true;

  function init() {
    var grid = document.querySelector('#rcds-results[data-rcds-page-size]');
    if (!grid) return;
    var pageSize = parseInt(grid.getAttribute('data-rcds-page-size'), 10);
    if (!pageSize || pageSize < 1) return;

    var wrap = document.querySelector('[data-rcds-more-wrap]');
    var btn = wrap ? wrap.querySelector('[data-rcds-loadmore]') : null;
    var baseLabel = btn ? btn.textContent.trim() : 'Load More Products';
    var page = 1;

    function visible() {
      var out = [], items = grid.querySelectorAll('.rcds-fitem'), i;
      for (i = 0; i < items.length; i++) { if (!items[i].hidden) out.push(items[i]); }
      return out;
    }

    function render() {
      var vis = visible(), limit = pageSize * page, i;
      for (i = 0; i < vis.length; i++) {
        vis[i].classList.toggle('rcds-fitem--over', i >= limit);
      }
      var remaining = vis.length - limit;
      if (!wrap) return;
      if (remaining > 0) {
        wrap.hidden = false;
        if (btn) btn.textContent = baseLabel + ' (' + remaining + ' more)';
      } else {
        wrap.hidden = true;
      }
    }

    if (btn) {
      btn.addEventListener('click', function () { page += 1; render(); });
    }
    // Facet change re-filters the grid; re-page the new visible set from the top.
    document.addEventListener('rcds:facets-applied', function () { page = 1; render(); });

    render();
  }

  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
})();
